var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C1FF3C;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1_00000179641240650484036890000001339033355771916679_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2090588411024"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M717.5,410.4v-61.3h-61.3v-123h-61.3v123H472.1v307h61.3V410.4h61.3v245.7h122.7v-61.3h-61.3V410.4H717.5 L717.5,410.4z M379.8,564.1c0,16.9-13.7,30.7-30.7,30.7H226.4v-123h122.7c16.9,0,30.7,13.7,30.7,30.7v61.3V564.1z M349.1,441.1 L349.1,441.1L349.1,441.1z M226.4,287.4h92c16.9,0,30.7,13.7,30.7,30.7v61.3c0,16.9-13.7,30.7-30.7,30.7h-92v-123V287.4z  M390.3,433.7v-8.5c12.7-11.3,20.4-27.5,20.4-45.8V305c0-43.7-35.6-79.3-79.3-79.3l0,0H165.1v430h194.6 c45.1,0,81.8-36.7,81.8-81.8v-71.6C441.5,470.7,420.7,442.9,390.3,433.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitIcon);
export default __webpack_public_path__ + "static/media/bit_icon.09f092e96c8c5f574e11372cffad8561.svg";
export { ForwardRef as ReactComponent };